import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import CampaignList from './relances/CampaignList';
import CampaignDetail from './relances/CampaignDetail';
import RelanceBuilder from './relances/RelanceBuilder';
import TemplateList from './relances/TemplateList';
import CommunicationsLog from './relances/CommunicationsLog';
import CommunicationCalendar from './relances/CommunicationCalendar';
import CommunicationTest from './relances/CommunicationTest';
import ManualCampaigns from './ManualCampaigns';
import RelancesDashboard from './relances/RelancesDashboard';

const TABS = [
  { id: 'dashboard', label: 'Tableau de bord', icon: '📊' },
  { id: 'campaigns', label: 'Campagnes', icon: '📣' },
  { id: 'manual', label: 'Campagnes manuelles', icon: '✉️' },
  { id: 'builder', label: 'Nouvelle Campagne', icon: '➕' },
  { id: 'test', label: 'Test', icon: '🧪' },
  { id: 'templates', label: 'Templates', icon: '📝' },
  { id: 'communications', label: 'Envois & Logs', icon: '📜' },
  { id: 'calendar', label: 'Calendrier', icon: '📆' },
];

export default function Relances() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('campaigns');
  const [selectedCampaignId, setSelectedCampaignId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [initialScheduledAt, setInitialScheduledAt] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    const campaignId = params.get('campaignId');
    const scheduled = params.get('scheduled');
    if (tab) setActiveTab(tab);
    if (campaignId) setSelectedCampaignId(campaignId);
    if (scheduled) setInitialScheduledAt(scheduled);
  }, [location.search]);

  const handleCampaignCreated = (campaign) => {
    setSelectedCampaignId(campaign.id);
    setActiveTab('campaigns');
    setRefreshKey(k => k + 1);
  };

  const handleViewCampaign = (campaignId) => {
    setSelectedCampaignId(campaignId);
  };

  const handleBackToList = () => {
    setSelectedCampaignId(null);
    setRefreshKey(k => k + 1);
  };

  const handleTemplateSelect = (template) => {
    setActiveTab('builder');
  };

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="rounded-2xl border border-slate-200 bg-gradient-to-br from-slate-50 via-white to-slate-100 p-6 mb-6">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-white border border-slate-200 px-3 py-1 text-xs text-slate-500">
              Communication • Email & WhatsApp
            </div>
            <h1 className="text-2xl font-bold text-slate-900 mt-2">
              Communication
            </h1>
            <p className="text-slate-500 mt-1">
              Campagnes multi‑canal avec ciblage, programmation et suivi détaillé.
            </p>
          </div>
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => setActiveTab('builder')}
              className="px-4 py-2 rounded-lg bg-slate-900 text-white hover:bg-slate-950 font-semibold text-sm"
            >
              ➕ Nouvelle campagne
            </button>
            <Link
              to="/agenda"
              className="px-4 py-2 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 font-semibold text-sm"
            >
              📅 Ouvrir agenda
            </Link>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="mb-6">
        <div className="flex flex-wrap gap-2">
          {TABS.map(tab => (
            <button
              key={tab.id}
              onClick={() => {
                setActiveTab(tab.id);
                if (tab.id !== 'campaigns') setSelectedCampaignId(null);
              }}
              className={`px-3 py-2 rounded-lg border text-sm font-medium transition-colors ${
                activeTab === tab.id
                  ? 'bg-slate-900 text-white border-slate-900'
                  : 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50'
              }`}
            >
              <span className="mr-2">{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="bg-white border border-slate-200 rounded-2xl p-5">
        {activeTab === 'dashboard' && (
          <RelancesDashboard />
        )}

        {activeTab === 'campaigns' && (
          selectedCampaignId ? (
            <CampaignDetail
              campaignId={selectedCampaignId}
              onBack={handleBackToList}
            />
          ) : (
            <CampaignList
              key={refreshKey}
              onViewCampaign={handleViewCampaign}
              onNewCampaign={() => setActiveTab('builder')}
            />
          )
        )}

        {activeTab === 'manual' && (
          <ManualCampaigns />
        )}

        {activeTab === 'builder' && (
          <RelanceBuilder
            onCampaignCreated={handleCampaignCreated}
            onCancel={() => setActiveTab('campaigns')}
            initialScheduledAt={initialScheduledAt}
          />
        )}

        {activeTab === 'templates' && (
          <TemplateList
            onSelectTemplate={handleTemplateSelect}
          />
        )}

        {activeTab === 'test' && (
          <CommunicationTest />
        )}

        {activeTab === 'communications' && (
          <CommunicationsLog />
        )}

        {activeTab === 'calendar' && (
          <CommunicationCalendar
            onOpenCampaign={(id) => {
              if (id) {
                setSelectedCampaignId(id);
                setActiveTab('campaigns');
              }
            }}
          />
        )}
      </div>
    </div>
  );
}
